import ReactDOM from "react-dom";

function unMountPreviousComponent(elementId) {
  ReactDOM.unmountComponentAtNode(document.getElementById(elementId));
}

export default unMountPreviousComponent;
